;(function($){

    function Copy_goals() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

        if($("#modal-copy-goals").length > 0) {

            $("#modal-copy-goals").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                },
                onOpening: function(modal){ 

                    _.modal = modal;                   

                    modal.startLoading();               

                    $.get(_.API + "gestao-de-contratos/metas", function(data) {

                       
                            _.metas = '<option value="">Selecione</option>';

                            $.each(data, function(index, value) {
                               _.metas += '<option value="'+ index +'" >'+ value +'</option>';
                            });

                            _.CurrenteDate = new Date();
                            _.CurrenteYear = _.CurrenteDate.getFullYear();

                            _.Years     = '<option value="">Selecione</option>';

                            for (i = _.CurrenteYear; i >= 1900; i--) { 
                                _.Years  += '<option value="'+ i +'" >'+ i +'</option>';
                            };
                                 
                            _.html = '<form id="form-copy-goals" enctype="multipart/form-data">'+
                            '<div class="row">' +
                                '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="meta">Meta a Ser Copiada</label>' +
                                        '<select name="meta" id="meta">'+_.metas+'</select>' +
                                    '</div>'+
                                '</div>'+                                                    
                           '</div>'+
                           '<div class="row">' +
                                '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="months">Mês à Atribuir</label>' +
                                        '<select name="months" id="months">' +
                                        '<option value="">Selecione</option>'+
                                        '<option value="01">Jan</option>'+
                                        '<option value="02">Fev</option>'+
                                        '<option value="03">Mar</option>'+
                                        '<option value="04">Abr</option>'+
                                        '<option value="05">Mai</option>'+
                                        '<option value="06">Jun</option>'+
                                        '<option value="07">Jul</option>'+
                                        '<option value="08">Ago</option>'+
                                        '<option value="09">Set</option>'+
                                        '<option value="10">Out</option>'+
                                        '<option value="11">Nov</option>'+
                                        '<option value="12">Dez</option>'+
                                        '</select>' +
                                    '</div>'+
                                '</div>'+
                                '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                                    '<div class="form-row">' +
                                        '<label for="years">Ano à Atribuir</label>' +
                                        '<select name="years" id="years">'+ _.Years +'</select>' +
                                    '</div>'+
                                '</div>'+ 
                            '</div>'+
                            '<div class="row">' +
                                '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                    '<div class="form-row">' +
                                      '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                    '</div>'+
                                '</div>'+                             
                           '</div></form>';  
                                        
            
                    }).done(function() {
                        if(_.html != ""){
                            $('#modal-copy-goals').iziModal('setTitle', '<i class="fa fa-circle-plus" aria-hidden="true"></i> Copiar Metas');
                            $("#modal-copy-goals .content").html(_.html);

                            _.myForm = $("#form-copy-goals").validate({
                                rules: {
                                    meta: { required: true },
                                    months: { required: true },
                                    years: { required: true }
                                },
                                messages: {
                                    meta: { required: "Campo Obrigatório" },
                                    months: { required: "Campo Obrigatório" },
                                    years: { required: "Campo Obrigatório" }
                                },
                                invalidHandler: function(e) {
                                    swal({
                                        title: "Atenção!",
                                        text: "Preencha todos os campos.",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "OK!",
                                        closeOnConfirm: true
                                    });

                                },
                                submitHandler: function( form ) {
                                
                                    $("#form-copy-goals .btn-send").html("Enviando...");
                                    
                                    $.ajax({
                                        type: "POST",
                                        url: _.API + "gestao-de-contratos/metas",
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        data: new FormData(form),
                                        success: function(result)
                                        {
                                            $("#form-copy-goals .btn-send").html("Enviar");

                                            form.reset();

                                            $('#modal-copy-goals').iziModal('close'); 

                                            swal({
                                                title: result.message,
                                                text: "Click no botão para fechar!",
                                                type: "success",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: false
                                            }).then(function() {
                                              location.reload();
                                            });                                        
                                        },
                                        error: function(response) {
                                            var errors = $.parseJSON(response.responseText);
                                            
                                            swal({
                                                title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                                text: "Click no botão para fechar!",
                                                type: "warning",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: true
                                            });

                                           
                                            $myForm.showErrors(errors);
                                            
                                            $("#form-copy-goals .btn-send").html("Enviar");
                                        }
                                    });
                                }
                            });
                        }
                    });          
                },
                onClosed: function() {
                    _.uri          = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-copy-goals .content").html("");
                    $('#modal-copy-goals').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-copy-goals").on("click", function(e){
            e.preventDefault();
            $('#modal-copy-goals').iziModal('open');           
        });
    }

   	new Copy_goals();

}(jQuery));